module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/10x8-5ae905c995f3f1a97494eee15f2757ba.svg";